import React from 'react';

import IUserDepartament from '../interfaces/IUserDepartament';
import List from '../components/List/List';

interface Props {
  userDepartaments: IUserDepartament[];
  setUserDepartaments: React.Dispatch<React.SetStateAction<IUserDepartament[]>>;
}

const UserDepartament: React.FC<any> = ({
  userDepartaments,
  setUserDepartaments,
}: Props) => {
  const handleUpdateUserDepartament = (
    seqDepartamento: number,
    membroDepartamento: boolean
  ): void => {
    setUserDepartaments((records) => [
      ...records.map((record) => {
        if (record.seqDepartamento === seqDepartamento) {
          return {
            ...record,
            membroDepartamento: membroDepartamento ? 'S' : 'N',
          };
        }
        return record;
      }),
    ]);
  };

  return (
    <div
      className="table-responsive overflow-hidden"
      style={{
        borderRadius: '0.68rem',
        borderColor: 'transparent',
      }}
    >
      <div
        className="w-100 text-white p-2"
        style={{ backgroundColor: '#1A1A1A' }}
      >
        <span style={{ fontSize: '1.25rem', fontWeight: '600' }}>
          Departamentos vinculados ao usuário
        </span>
      </div>
      <div
        className="rounded w-100 border-0 overflow-auto"
        style={{
          height: '19rem',
        }}
      >
        <List
          key="user-departament-list"
          data={userDepartaments}
          handleUpdateRegister={handleUpdateUserDepartament}
          idField="seqDepartamento"
          nameField="nomeDepartamento"
          checkedField="membroDepartamento"
        />
      </div>
    </div>
  );
};

export default UserDepartament;
